import React from "react";
import { X } from "lucide-react";

export const TemplatePreviewModal = ({ template, onClose }) => {
    const handleUseTemplate = () => {
        // 1. Workflow create modal open with this template's tasks
        // 2. Or navigate(`/workflows/create?templateId=${template.id}`)
        alert(`Using template: ${template.name}`);
        onClose();
    };

     const formatText = (text = "") =>
    text
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

    return (
        <div 
        onClick={(e) => e.stopPropagation()}
            className="p-0" >
                {/* <div className="flex justify-between items-center mb-0">
                    <h3 className="text-lg font-semibold text-gray-900">
                        {formatText(template.name) || ""}
                    </h3>
                    <button
                        onClick={onClose}
                        className="p-1 text-red-600 bg-red-50 hover:bg-red-100"
                    >
                        <X size={20} />
                    </button>
                </div> */}

                <p className="text-sm text-gray-700 mb-1">
                    {template.description || "No description provided."}
                </p>

                <div className="space-y-1">
                    {(template.tasks || []).map((task, idx) => (
                        <div
                            key={idx}
                            className="py-1 px-2 border rounded-lg bg-white text-sm"
                        >
                            <p className="font-medium text-gray-800">{task.title}</p>
                            <p className="text-gray-600">{task.description}</p>
                            {/* <p className="text-xs text-gray-500">
                                {task.startDate} → {task.dueDate}
                            </p> */}
                        </div>
                    ))}
                </div>

                {/* <div className="mt-2 flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-1 border rounded-lg text-red-700 bg-red-50 hover:bg-red-100"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleUseTemplate}
                        className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary"
                    >
                        Start Workflow
                    </button>
                </div> */}
        </div>
    );
};
